module.exports = __webpack_public_path__ + "c6bf7ae437098489d186fc64c7c67a61.fbx";